/**
 * @author fackin
 * @LastEditTime: Do not edit
 * @Description
 * @Date: 2019-03-13 10:41:43
 */
import Row from './src/row';

Row.install = function (Vue) {
  Vue.component(Row.name, Row);
}
export default Row;



// WEBPACK FOOTER //
// ./packages/row/index.js